import React from "react"
import {usePublishPollMutation} from "@irati/recognition/hooks"
import {match as Match} from "react-router-dom"
import GenericModal from "@irati/ui/src/GenericModal"
import History, {historyContext} from "@irati/utils/history"
import PrimaryButton from "@irati/ui/src/Button"
import id from "@irati/utils/id"
import Flex from "@irati/ui/src/Flex"
import authentication from "@irati/auth"
import Error from "@irati/ui/src/Loading/Error"
import {Body} from "@irati/ui/src/Typography"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import {RecognitionRoutes} from "../../../enums/Routes"
import {Poll, PollStatus} from "@irati/types"
interface Props {
  match: Match
  poll: Poll
}
const PublishPollModal = (props: Props, context) => {
  const intl = useIntl()
  const {match, poll} = props
  const {uuid: pollId} = match.params as {uuid: string}
  const [publishPoll, {loading: publishing, error, errorMsg}] = usePublishPollMutation({
    variables: {
      pollId
    }
  })
  const onClose = () => {
    History.push(RecognitionRoutes.MY_ACCOUNT_CLOSED_POLLS, context, {
      scrollToTop: false
    })
  }
  const handlePublishPoll = () => {
    publishPoll().then(onClose)
  }
  const isAuthor = authentication.user().uuid === poll?.createdBy?.uuid
  if (!poll) {
    return null
  }
  return (
    <GenericModal title={intl.formatMessage({id: "recognition.polls.modal.title.publishPoll"})} show={pollId} critical hideActions>
      {poll.status === PollStatus.Closed && (
        <Body>
          <FormattedMessage id="recognition.polls.modal.msg.publishPollClosed" />
        </Body>
      )}
      {isAuthor && poll.status === PollStatus.ClosedUnpublished && (
        <>
          <Body>
            <FormattedMessage id="recognition.polls.modal.msg.publishPoll" />
          </Body>
          <Flex alignItems="center" justifyContent="flex-end" gap={3} marginTop={2}>
            <PrimaryButton id={id("quit", props)} onClick={onClose}>
              <FormattedMessage id="platform.recognition.polls.btn.closedPollsCancel" />
            </PrimaryButton>
            <PrimaryButton primary id={id("continue", props)} loading={publishing} onClick={handlePublishPoll} marginRight={2}>
              <FormattedMessage id="platform.recognition.polls.btn.closedPollsPublish" />
            </PrimaryButton>
          </Flex>
        </>
      )}
      {!isAuthor && poll.status === PollStatus.ClosedUnpublished && (
        <Body>
          <FormattedMessage id="recognition.polls.modal.msg.publishPollNotAuthor" />
        </Body>
      )}
      {error && <Error errorMsg={errorMsg} error={error} />}
    </GenericModal>
  )
}
PublishPollModal.contextTypes = historyContext
export default PublishPollModal
